import React from "react";
import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <p className={styles.footerText}>© IoT Global Solutions s.r.o. All rights reserved.</p>
    </div>
  );
};

export default Footer;
